// removed by extract-text-webpack-plugin
module.exports = {"sea-buckthron":"#faa634","black":"#000000","white":"#ffffff","iron":"#d3d3d3","shark":"#2a2a32","christine":"#e0760b"};


//////////////////
// WEBPACK FOOTER
// ./src/app/App.css
// module id = 185
// module chunks = 4